<template>
  <div class="SetLoginPassword">
    <el-dialog :title="title + $t('myAccount.text104')" v-model="SetLoginPasswordModelFlag" width='500px'
      class="dialog-box" :close-on-click-modal="false" destroy-on-close @closed="beforeClose">
      <div class="phone-con input-row" v-if="pageType == 2">
        <div class="value"><input type="email" disabled v-model="emailData.email"
            :placeholder="$t('components.text16')" /></div>
      </div>
      <div class="code-input input-row" v-if="pageType == 2">
        <div class="value">
          <input class="value_code" v-model="emailData.code" type="text" :placeholder="$t('components.text17')" />
        </div>
        <el-button class="send" link @click="sendEmailCode">{{ sendMessage }}</el-button>
      </div>

      <PhoneInputBox :blurFunc="phoneBlur" :value="phoneData.phone" :code="phoneData.mobileAreaCode"
        v-if="pageType == 1" />
      <CodeInputBox :blurFunc="codeBlur" :mobileAreaCode="phoneData.mobileAreaCode" :phone="phoneData.phone"
        :value="phoneData.code" :smsType='phoneData.smsType' :placeholder="$t('signUp.text15')" v-if="pageType == 1" />
      <PasswordInputBox :blurFunc="pwdBlur" :value="phoneData.pwd" :placeholder="$t('signUp.text31')"
        :errorFlag="errorFlag" :errText="$t('signUp.text33')" />
      <PasswordInputBox :blurFunc="pwdBlur2" :value="phoneData.pwd2" :placeholder="$t('signUp.text32')" />
      <div class="change_page_type" @click="changePageType" v-show="pageFlag == 3">{{ pageType ==
        1 ? $t('myAccount.text168') : $t('myAccount.text169') }}</div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="SetLoginPasswordModelFlag = false">{{ $t('trade.text72') }}</el-button>
          <el-button type="primary" :loading='loading' :disabled="!submitFlag" @click="Confirm">{{ $t('trade.text73')
            }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  computed,
  inject,
  onBeforeUnmount
} from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";
import { isNotEmpty } from "@/until/common";

export default {
  name: 'SetLoginPassword',
  setup() {
    const emitt = inject('emitt');
    const store = useStore();
    const { t } = useI18n()

    const SetLoginPasswordModelFlag = ref(false)
    const loading = ref(false)
    const errorFlag = ref(false);//密码错误提示
    const title = ref('');
    const isSending = ref(false);
    let timer = null;
    const time = ref(60);
    //发送手机验证码按钮文本
    const sendMessage = ref(t('signUp.text16'))
    const userInfo = computed({
      get: () => {
        return store.state.user.userInfo;
      },
    });
    const pageType = ref(store.getters.getAgentConfig.phoneLoginReg ? 1 : 2);// 1.手机号修改 2.邮箱修改
    const pageFlag = computed({//1.只存在手机号 2.只存在邮箱 3.两个都存在
      get: () => {
        if (store.getters.getAgentConfig.phoneLoginReg && store.getters.getAgentConfig.emailLoginReg) {
          if (store.state.user.userInfo.phone && store.state.user.userInfo.email) {
            return 3
          } else if (store.state.user.userInfo.phone) {
            return 1
          } else if (store.state.user.userInfo.email) {
            return 2
          }
        } else if (store.getters.getAgentConfig.phoneLoginReg) {
          return 1
        } else if (store.getters.getAgentConfig.emailLoginReg) {
          return 2
        }
      }

    });
    /**
     * 打开弹框-开始
     */
    emitt.$sub('openSetLoginPassword', (val) => {
      title.value = val[0].title;
      phoneData.phone = userInfo.value.phone;
      emailData.email = userInfo.value.email
      phoneData.mobileAreaCode = userInfo.value.mobileAreaCode;
      if (!isNotEmpty(phoneData.phone)) {
        pageFlag.value = 2;
        pageType.value = 2
      }
      if (!isNotEmpty(emailData.email)) {
        pageFlag.value = 1;
        pageType.value = 1;
      }

      SetLoginPasswordModelFlag.value = true;

    });
    onBeforeUnmount(() => {
      emitt.$unsub("openSetLoginPassword");
    });
    /**
     * 打开弹框-开始
     */

    const emailData = reactive({
      email: '',
      code: '',
      smsType: '22',//验证类型
    });

    /**
    * 电话验证参数-开始
    */
    const phoneData = reactive({
      phone: "",//手机号
      code: "",//验证码
      smsType: '22',//验证类型
      mobileAreaCode: '',//国际区号
      pwd: '',
      pwd2: ''
    })
    /**
    * 电话验证参数-结束
    */

    /**
     * 组件赋值操作-开始
     */
    function codeBlur(val) {
      phoneData.code = val;
    }
    function phoneBlur(val) {
      phoneData.phone = val;
    }
    function pwdBlur(val) {
      errorFlag.value = false;
      phoneData.pwd = val;
    }
    function pwdBlur2(val) {
      errorFlag.value = false;
      phoneData.pwd2 = val;
    }


    /**
     * 邮箱发送验证码-开始
     */
    const sendEmailCode = async () => {
      console.log('sendCode');
      if (isSending.value) {
        return;
      }

      if (emailData.email == '') {
        ElMessage({
          message: t('signUp.text42'),
          type: 'error',
        })
        return
      }

      if (checkEmailPatern(emailData.email)) {
      } else {
        ElMessage({
          message: t('signUp.text43'),
          type: 'error',
        })
        return
      }
      await sendEmailCodeFunc();
    };
    /**
     * 组件赋值操作-结束
     */

    // 检查邮箱
    function checkEmailPatern(value) {
      const cpVal = value.replace(/\s+/g, '');
      const myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,9}$/;
      return myreg.test(cpVal);
    }
    async function sendEmailCodeFunc() {
      if (timer) {
        return;
      }
      isSending.value = true;
      sendMessage.value = t('signUp.text18');
      let res;
      const params = {
        smsType: emailData.smsType,
        email: window.btoa(emailData.email),
      };
      res = await apiService.GetByEmail(params);
      if (res.status === 1) {
        sendMessage.value = `${time.value}S`;
        timer = setInterval(() => {
          sendMessage.value = `${time.value}S`;
          time.value -= 1;
          if (time.value <= 0) {
            isSending.value = false;
            clearInterval(timer);
            sendMessage.value = t('signUp.text17');
            time.value = 60;
            timer = null;
          }
        }, 1000);
      } else {
        ElMessage({
          message: res.message,
          type: 'error',
        })
        sendMessage.value = t('signUp.text16');
        isSending.value = false;
      }
    }
    /**
     * 手机验证按钮提交条件-开始
     */
    const submitFlag = computed(() => {
      return (phoneData.phone != "" &&
        phoneData.pwd != "" &&
        phoneData.pwd2 != "" &&
        phoneData.code != "") || (
          emailData.email != "" &&
          phoneData.pwd != "" &&
          phoneData.pwd2 != "" &&
          emailData.code != ""
        )
    })
    /**
     * 手机验证按钮提交条件-结束
     */



    /**
    * 手机验证提交-开始
    */

    function Confirm() {

      if (phoneData.pwd !== phoneData.pwd2) {
        errorFlag.value = true;
        return
      }

      let mask = /^[\da-z]+$/i
      if (!mask.test(phoneData.pwd)) {
        ElMessage({
          message: t('signUp.text37'),
          type: 'error',
        })
        return
      }

      if (!submitFlag.value) {
        return;
      }
      loading.value = true;
      const params = {
        smsType: phoneData.smsType,
        code: pageType.value == 1 ? phoneData.code : emailData.code,
        account: pageType.value == 1 ? window.btoa(phoneData.phone) : window.btoa(emailData.email),
        mobileAreaCode: phoneData.mobileAreaCode
      };

      apiService.CheckVerifyCode(params).then((res) => {
        if (res.status == 1) {
          SetPassword();
        } else {
          ElMessage({
            message: res.message,
            type: 'error',
          });
        }
        loading.value = false;

      });
    }
    /**
     * 手机验证提交-结束
     */


    /**
     * 设置密码-开始
     */
    function SetPassword() {
      let params = {
        password: window.btoa(phoneData.pwd),
      }
      console.log(params)
      apiService.SetPassword(params).then(res => {
        if (res.status == 1) {
          store.dispatch('getUserStatus');

          ElMessage({
            message: t('signUp.text36'),
            type: 'success',
          });
          SetLoginPasswordModelFlag.value = false;
        } else {
          ElMessage({
            message: res.message,
            type: 'error',
          });
        }
      })
    }
    /**
     * 设置密码-结束
     */

    function changePageType() {
      pageType.value = pageType.value == 1 ? 2 : 1
    }
    function beforeClose() {
      phoneData.code = '';
      emailData.code = '';
    }
    return {
      beforeClose,
      changePageType,
      pageFlag,
      pageType,
      emailData,
      sendMessage,
      sendEmailCode,
      SetLoginPasswordModelFlag,
      phoneData,
      submitFlag,
      loading,
      Confirm,
      codeBlur,
      phoneBlur,
      pwdBlur,
      pwdBlur2,
      errorFlag,
      title,
    }
  }
}
</script>
<style lang="less" scoped>
.SetLoginPassword {
  .change_page_type {
    color: #51B4F1;
    cursor: pointer;
  }

  .input-row {
    margin: 0 auto;
    background: white;
    display: flex;
    justify-content: left;
    margin-bottom: 20px;
    border-radius: 4px;
    height: 40px;
    /*no*/
    position: relative;
    border: 1px solid #EBEBEB;

    /*no*/
    .value {
      /*no*/
      width: 100%;
      /*no*/
    }

    .password-icon {
      position: absolute;
      right: 16px;
      /*no*/
      top: 10px;
      /*no*/
      cursor: pointer;
    }

    .send {
      position: absolute;
      right: 10px;
      /*no*/
      top: 10px;
      /*no*/
    }

    .prefix {
      width: 80px;
      /*no*/
      padding-left: 10px;
      /*no*/
      border-right: 1px solid #EBEBEB;
      /*no*/
      text-align: left;
      cursor: pointer;
      position: relative;
      line-height: 40px;

      /*no*/
      .icon_search {
        position: relative;
        top: 8px;
        /*no*/
      }

      .icon_choice {
        width: 8px;
        /*no*/
        position: absolute;
        right: 9px;
        /*no*/
        top: 18px;
        /*no*/
      }
    }

    input {
      height: 38px;
      border-radius: 4px;
      /*no*/
      outline: none;
      padding-left: 16px;
      /*no*/
      width: 100%;
    }

    .value_code {
      padding-left: 10px;
      /*no*/
    }

    .select_region {
      position: absolute;
      left: 0;
      padding: 20px 0;
      /*no*/
      background: white;
      width: 300px;
      /*no*/
      height: 490px;
      /*no*/
      z-index: 9;
      top: 50px;
      /*no*/
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

      h3 {
        font-size: 16px;
        text-align: center;
        color: #111E36;
        position: relative;

        img {
          display: none;
        }
      }

      .seach {
        width: 284px;
        /*no*/
        height: 32px;
        /*no*/
        background: #FFFFFF;
        border-radius: 2px;
        margin: 0 auto;
        border: 1px solid #DADADA;
        /*no*/
        display: flex;
        justify-content: space-between;
        padding-left: 13px;
        /*no*/
        margin-top: 19px;

        /*no*/
        img {
          display: block;
          width: 12px;
          /*no*/
          height: 12px;
          /*no*/
          position: relative;
          top: 8px;
          /*no*/
        }

        input {
          width: 243px;
          /*no*/
          height: 28px;
          /*no*/
          line-height: 28px;
          /*no*/
          padding-left: 0;
        }
      }

      ul {
        width: 100%;
        height: 360px;
        /*no*/
        margin-top: 12px;
        /*no*/
        overflow-y: scroll;
        text-align: left;

        li {
          height: 45px;
          /*no*/
          padding: 13px 16px;
          /*no*/
          border-bottom: 1px solid #F8F9FB;
          /*no*/
          cursor: pointer;
        }

        li:hover {
          background: #F7F8FA;
          color: #51B4F1;
        }

        .sort_list_active {
          background: #F7F8FA;
          color: #51B4F1;
        }
      }
    }
  }
}
</style>
